import React, { useState } from "react";
import { Grid, Typography, FormControlLabel, Checkbox } from "@material-ui/core";
import { useForm } from "react-hook-form";
import WizardButtons from './WizardButtons';
import useTranslation from "../../application/translation";

export default function FormGdpr({ handleBack, handleNext }) {
    const { register, handleSubmit } = useForm({ mode: "onChange" });
    const translation = useTranslation();
    const [approved, setApproved] = useState(false);
    const [verified, setVerified] = useState(false);

    const onSubmit = () => {
        handleNext();
    };

    const handleApproved = (event) => {
        setApproved(event.target.checked);
    };

    const handleVerified = (event) => {
        setVerified(event.target.checked);
    };

    return (
        <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        {translation.gdpr_header1}<br />
                        {translation.gdpr_header2}
                    </Typography>
                    <Typography variant="body2">
                        {translation.gdpr_text}
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                id="gdpr-approve"
                                {...register("gdprApprove")}
                                defaultChecked={false}
                                onChange={handleApproved}
                                inputProps={{ 'aria-label': translation.gdpr_approve1 }}
                            />
                        }
                        label={translation.gdpr_approve1}
                    />
                </Grid>

                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                id="gdpr-verify"
                                {...register("verifychbx")}
                                defaultChecked={false}
                                onChange={handleVerified}
                                inputProps={{ 'aria-label': translation.gdpr_approve2 }}
                            />
                        }
                        label={translation.gdpr_approve2}
                    />
                </Grid>

                <WizardButtons
                    handleBack={handleBack}
                    isStepValid={approved && verified}
                    nextButtonLabel={translation.button_sign}
                />
            </Grid>
        </form>
    );
}
